import React from "react";
import "./12Statistics.css";

const VIP12Statistics = ({ projectId = "12" }) => {
  return (
    <div className="vip12-statistics-container">
      <div className="vip12-statistics-header">
        <h1 className="vip12-statistics-title">REBOA RCT Statistics</h1>
        <p className="vip12-statistics-subtitle">
          Project Statistics Dashboard
        </p>
      </div>

      <div className="vip12-statistics-content">
        <div className="preparation-notice">
          <div className="notice-icon">📊</div>
          <h2 className="notice-title">Statistics Dashboard</h2>
          <p className="notice-message">
            The statistics dashboard is currently under development.
            <br />
            Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VIP12Statistics;
